import type { VueElement } from 'vue'

import type { LAppLayoutsEnum } from '~/portal/layouts/LApp'

export enum RoutesNamesEnum {
	home = 'home',
	login = 'login',
	notFound = 'not-found',
	dataProtection = 'data-protection',
	documentChecking = 'document-checking',
	certificatesMonitor = 'certificates-monitor'
}

declare module 'vue-router' {
	interface RouteMeta {
		layout?: LAppLayoutsEnum
		layoutComponent?: VueElement
	}
}
